import api from './api';

export const userService = {
  async getProfile() {
    const response = await api.get('/user/profile');
    return response.data;
  },

  async updateProfile(profileData) {
    const response = await api.put('/user/profile', profileData);
    return response.data;
  },

  async updatePreferences(preferences) {
    const response = await api.put('/user/preferences', preferences);
    return response.data;
  },

  async getLinks() {
    const response = await api.get('/user/links');
    return response.data;
  },

  async updateLinks(links) {
    const response = await api.put('/user/links', links);
    return response.data;
  },

  async uploadAvatar(formData) {
    const response = await api.post('/user/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async deleteAccount(password) {
    const response = await api.delete('/user/account', {
      data: { password }
    });
    return response.data;
  },
};
